import React, {useEffect, useState} from "react";
import { Counter } from "../../../components/Counter/Counter";
import { CURRENCY } from "../../../helper/constant";
import { CloseIcon } from "../../../assets/icons/close";
import { PencilIcon } from "../../../components/AllSvgIcon";
import DeleteIcon from '@material-ui/icons/Delete';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import { Modal } from "react-bootstrap";
import {
  ItemBox,
  Image,
  Information,
  Name,
  Price,
  Weight,
  Total,
  RemoveButton,
  EditButton,
  Input,
  BannerImageContainer,
  Banner,
  Errormsg
} from "./CartItem.style";
import Button from "../../../components/Button/Button";
import { isTodayApplicable } from "../../../constants/Constant";
import t from '../../../i18n/translate';

export const CartItem = ({ data, onDecrement, onIncrement, onRemove, onUpdate, cartType, isLoading }) => {
  const startDate = new Date(data.store_item_infos[0].promo_start_date).getTime();
  const expiredDate = new Date(data.store_item_infos[0].promo_end_date).getTime();
  const now = new Date().getTime();

  const { quantity } = data;
  // const displayPrice = data.item_price;
  const displayPrice = (!(startDate < now && now < expiredDate) || data.store_item_infos[0].promo === 0 || data.store_item_infos[0].promo_price === null) ?  Number(data.store_items_price_types[0].price) : Number(data.store_item_infos[0].promo_price);

  const totalPrice = quantity * displayPrice;
  const [newquantity, setNewQuantity] = useState(quantity);
  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState(false);
  const handleQuantityUpdate = (quant) => {
    setNewQuantity(quant);
  };

  useEffect(() => {    
    window.onpopstate = () => {
      window.location.reload();
    }
 }, []);

  return (
    <ItemBox>
      {/* <Counter
        className={`pr${data.item_id} ${cartType}`}
        value={quantity}
        onDecrement={onDecrement}
        onIncrement={onIncrement}
        onUpdate={(quantity)=>onUpdate(quantity)}
        variant="lightVertical"
        isLoading={false} // never loading the counter
      /> */}
      <BannerImageContainer>
        {cartType !== 'express' ? (
          data.store_item_infos[0].same_day === 1 && data.store_item_infos[0].is_shop_normal_open === true
            ? 
              <Banner className={`bg-success pb-1 px-1 rounded text-white ${cartType}`}>
                { t('shop_item_get_same_day') }
              </Banner>
            : data.store_item_infos[0].available_tommorrow ? <Banner className={`bg-warning pb-1 px-1 rounded text-white ${cartType}`}>
                { t('shop_item_get_tomorrow') }
              </Banner>
            :null
        ):(
          data.store_item_infos[0].same_day === 1 &&
            <Banner className={`bg-success pb-1 px-1 rounded text-white ${cartType}`}>
              { t('shop_item_get_same_day') }
            </Banner>
        )
        }
        {/* {data.store_item_infos[0].default_image_url === undefined || data.store_item_infos[0].default_image_url === null ?
          <Image src={require('../../../assets/images/delishop-favicons.png')} alt={"product image"} />
        : 
          <Image src={data.store_item_infos[0].default_image_url} alt={"product image"} />
        } */}
          <Image
            src={
              data.store_item_infos[0].default_image_url
                ? data.store_item_infos[0].default_image_url
                : require("../../../assets/images/delishop-favicons.png")
            }
            alt={data.item_name}
          />
      </BannerImageContainer>
      <Information>
        <div className="d-flex justify-content-between">
	        <Name className={cartType}>{data.item_name} </Name>
          <RemoveButton 
            className="ml-1"
            onClick={() => {
              onRemove();
              // let response = window.confirm( t('home_basket_alert_remove_item', false) );
              // if (response === true) {
              //   onRemove();
              // }
            }}>
              <CloseIcon />
            </RemoveButton>  
        </div>
        <Weight>
          {quantity} X{" "}
          {data.item_price_name}
        </Weight>
        <div className="d-flex align-items-center justify-content-between">
          <Price className={cartType}>
            {CURRENCY}
            {parseFloat(displayPrice).toFixed(2)}
          </Price>
          <Counter
            className={`pr${data.item_id} ${cartType} checkoutPopup`}
            value={quantity}
            onDecrement={onDecrement}
            onIncrement={onIncrement}
            onUpdate={(quantity)=>onUpdate(quantity)}
            variant="lightVertical"
            isLoading={false} // never loading the counter
          />
          <Total className={cartType}>
            {CURRENCY}
            {parseFloat(quantity * displayPrice).toFixed(2)}
          </Total>
        </div>
        {(data.dp_redeem_quantity ?? 0) > 0 && data.store_item_infos[0].dp_points && (
          <div className="d-flex align-items-center" style={{ marginTop: "4px", gap: "6px", color: "#5a9e2f" }}>
            <CardGiftcardIcon style={{ fontSize: "18px" }} />
            <span style={{ fontSize: "12px", fontWeight: 600 }}>
              -{data.dp_redeem_quantity * data.store_item_infos[0].dp_points} pts
            </span>
            <span style={{ fontSize: "12px", fontWeight: 600 }}>
              (-{CURRENCY}{(parseFloat(data.dp_discount_payment ?? 0) > 0 ? parseFloat(data.dp_discount_payment) : (parseFloat(data.item_price ?? 0) - parseFloat(data.store_item_infos[0].dp_price ?? 0)) * parseInt(data.dp_redeem_quantity ?? 0)).toFixed(2)})
            </span>
          </div>
        )}
      </Information>
      {/* <div className="ml-auto">
        <div className="d-flex align-items-center justify-content-end mb-3">      

          <EditButton onClick={()=>{setNewQuantity(quantity); setShow(true);}}>
            <PencilIcon cartType={cartType} />
          </EditButton>
        </div>            
      </div> */}




      <Modal
        show={show}
        onHide={() => {
          setShow(false);
          setNewQuantity(quantity);
        }}
        dialogClassName="modal-90w authModal"
        aria-labelledby="example-custom-modal-styling-title"
        backdrop="static"
      >
        <Modal.Header closeButton>
        <Modal.Title>{ t('home_basket_update_quantity_popup_title') }</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Input 
           onUpdate={handleQuantityUpdate}
           value={newquantity}/>
           {msg && <Errormsg>{ t('home_basket_error_value_greater_then_zero', false) }</Errormsg>}
        </Modal.Body>
        <Modal.Footer>
        <Button
          title={ t('home_basket_update_quantity_popup_button_save', false) }
          variant="primary"
          onClick={() => {
            if(newquantity > 0){
              onUpdate(newquantity);
              setShow(false);
              setMsg(false);
            }
            else{
              setMsg(true);
            }
          }}
        >
          { t('home_basket_update_quantity_popup_button_save', false) }
        </Button>
        </Modal.Footer>
      </Modal>
    </ItemBox>
  );
};
